export const SMART_POPUNDER_RESULTS_TABLE_COLUMNS = [
  {
    id: 'redirects',
    label: 'Redirects',
  },
  {
    id: 'impressions',
    label: 'Impressions',
  },
  {
    id: 'clicks',
    label: 'Clicks',
  },
  {
    id: 'ctr',
    label: 'CTR %',
  },
  {
    id: 'signups',
    label: 'Signups',
  },
  {
    id: 'signupsRate',
    label: 'Signup %',
  },
  {
    id: 'verifications',
    label: 'Verifications',
  },
  {
    id: 'verificationsRateBySignups',
    label: 'Verification %',
  },
  {
    id: 'firstBuys',
    label: 'First buys',
  },
  {
    id: 'firstBuysRate',
    label: 'RDR to FB %',
  },
  {
    id: 'weight',
    label: 'Weight',
  },
];

export const SMART_POPUNDER_RESULTS_TABLE_COLUMNS_IDS =
  SMART_POPUNDER_RESULTS_TABLE_COLUMNS.map((item) => item.id);
